import { pxToRem } from '../../../../utils';
var chatStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      backgroundColor: v.backgroundColor,
      border: "1px solid ".concat(v.backgroundColor),
      display: 'flex',
      flexDirection: 'column',
      listStyle: 'none',
      padding: "0 ".concat(pxToRem(10), " 0 ").concat(pxToRem(10)),
      margin: 0
    };
  }
};
export default chatStyles;